import { render } from "./HospitalPharmacySoftware.vue?vue&type=template&id=3f5f0f42"
import script from "./HospitalPharmacySoftware.vue?vue&type=script&lang=js"
export * from "./HospitalPharmacySoftware.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__